import React from 'react'
import PropTypes from 'prop-types'
import { withRouter } from 'react-router-dom'

import {
  Input,
  Spinner,
  Button,
  Heading,
  SvgIcon,
  TextArea,
  InfoDisplay,
  CenteredContainerDisplay,
  IdentityBankAccounts,
  Modal
} from '../'

import {
  decodeBase64,
} from '../../utils'

import { default as fragments } from '../../fragments'
import { graphql, compose } from 'react-apollo'
import gql from 'graphql-tag'

class EmployerInformation extends React.Component {
  static propTypes = {
    employer: PropTypes.string.isRequired
  }

  state = {
    edit: false,
    friendlyName: 'Loading',
    legalName: 'Loading',
    notes: 'Loading',
    showDownloadSuccessModal: false,
    saveInProgress: false
  }

  UNSAFE_componentWillReceiveProps(props) {
    let employer = props.data.employer

    if (employer) {
      this.setState({
        legalName: employer.identity.firstName+' '+employer.identity.lastName
      })
    }
  }

  goReadOnly = () => {
    this.setState({ edit: false, saveInProgress: false })
  }

  goEdit = () => {
    let employer = this.props.data.employer
    this.setState({
      edit: true,
      friendlyName: employer.friendlyName,
      notes: employer.notes
    })
  }

  noChangesToSave = (employer) => (
    employer.friendlyName === this.state.friendlyName && employer.notes === this.state.notes
  )

  handleUpdate = () => {
    this.setState({ saveInProgress: true })

    let employer = this.props.data.employer
    let employerInfo = {
      id: employer.id
    }

    if (employer.friendlyName !== this.state.friendlyName)
      employerInfo.friendlyName = this.state.friendlyName

    if (employer.notes !== this.state.notes)
      employerInfo.notes = this.state.notes

    if (Object.keys(employerInfo).length > 1) {  // check whether fields other than just 'id' exist on obj
      this.props.updateEmployer({variables: { input: employerInfo }})
        .then(this.goReadOnly)
        .catch(() => this.setState({ saveInProgress: false }))
    } else {
      this.setState({ saveInProgress: false })
    }
  }

  downloadFuneralCoverFile = () => {
    let body = new FormData()
    body.append('employer_uuid', decodeBase64(this.props.data.employer.id))

    fetch(`${process.env.REACT_APP_API_ROOT}/v1/funeralcoverdownload/`, {
      method: 'post',
      headers: {
        'Authorization': 'Token ' + localStorage.getItem('token') || null
      },
      body: body
    })
    .then((data) => {
      if (data.ok) {  // covers 200-range of http responses
        console.log('Download request successful.')
        this.setState({
          showDownloadSuccessModal: true
        })
      } else {
        console.log(`Download request failed.  HTTP: ${data.status} - ${data.statusText}`)
      }
      return data.json()
    })
    .catch((error) => {
      console.log('Download request failed', error)
    })
  }

  render() {
    if (this.props.data.loading) {
      return <Spinner />
    }

    if (this.props.data.error) {
      return <h1>Oh dear! We have an issue</h1>
    }

    let employer = this.props.data.employer

    let rows = (<tbody>
      <tr>
        <th className='slds-size_1-of-4 slds-theme--shade slds-text-heading--label slds-cell-wrap'>Friendly name</th>
        <td>{this.state.edit
            ? <Input
                id='friendlyName'
                placeholder='Friendly Name'
                value={this.state.friendlyName}
                onChange={(e) => this.setState({friendlyName: e.target.value})}
               />
            : employer.friendlyName
          }</td>
      </tr>
      <tr>
        <th className='slds-size_1-of-4 slds-theme--shade slds-text-heading--label slds-cell-wrap'>Legal name</th>
        <td>{this.state.legalName}</td>
      </tr>
      <tr>
        <th className='slds-size_1-of-4 slds-theme--shade slds-text-heading--label slds-cell-wrap'>Notes</th>
        <td className='slds-cell-wrap'>{this.state.edit
            ? <TextArea
                id='notes'
                placeholder='Notes'
                value={this.state.notes}
                onChange={(e) => this.setState({notes: e.target.value})}
               />
            : employer.notes
          }</td>
      </tr>
      <tr>
        <th className='slds-size_1-of-4 slds-theme--shade slds-text-heading--label slds-cell-wrap'>Funeral Cover</th>
        <td>
          <Button
            type='reset'
            onClick={this.downloadFuneralCoverFile}>
            <SvgIcon
              variant='picsaos'
              symbol='download'
            />
            <div className='u-text-caps'>Download</div>
          </Button>
        </td>
      </tr>
      <tr>
        <th className='slds-size_1-of-4 slds-theme--shade slds-text-heading--label slds-cell-wrap'>Bank account info</th>
        <td className='slds-cell-wrap'>
          <IdentityBankAccounts identityId={employer.identity.id} />
        </td>
      </tr>
      {this.state.showDownloadSuccessModal
        ? <Modal
            body={
              <CenteredContainerDisplay
                height={300}
                yAdjustPercentage={5}
                content={
                  <div
                    className='slds-size_2-of-3 slds-align_absolute-center'
                    style={{ display: 'block' }}>
                    <div className='slds-m-bottom_large slds-align_absolute-center circleIcon'>
                      <SvgIcon
                        variant='utility'
                        symbol='check'
                        size='large'
                        colour='success'
                      />
                    </div>
                    <div>
                      <Heading className='slds-text-align_center'>
                        {`The spreadsheet has been emailed to ${localStorage.getItem('userEmailAddress')}.  Should you not receive it within 10 minutes, please contact us`}
                      </Heading>
                    </div>
                  </div>
                }
              />
            }
            footer={
              <Button
                type='brand'
                onClick={() => this.setState({ showDownloadSuccessModal: false})}
                className='slds-align_absolute-center'>
                OK
              </Button>
            }
          />
        : null
      }
    </tbody>)

    return (
      <InfoDisplay
        title='Employer Information'
        rows={rows}
        edit={this.state.edit}
        onCancelClick={this.goReadOnly}
        onSaveClick={this.handleUpdate}
        onEditClick={this.goEdit}
        actionButtons={[
          <Button
            type='brand'
            onClick={() => this.props.history.push('/os/dashboard')}
            key='dashboard'>
            Dashboard
          </Button>,
          <Button
            type='brand'
            onClick={() => this.props.history.push(`/os/insights/impact/${this.props.employer}`)}
            key='impactReport'>
            Impact report
          </Button>
        ]}
        titleBold={false}
        saveDisabled={this.noChangesToSave(this.props.data.employer) || this.state.saveInProgress}
        saveButtonLabel={this.state.saveInProgress ? 'Saving...' : null}
        className='slds-m-bottom_x-large'
      />
    )
  }
}

const getEmployerInformation = gql`query($id: ID!) {
    employer(id: $id) {
      ...EmployerInformation
    }
  }
  ${fragments.employerInformation}
`

const updateEmployer = gql`
  mutation updateEmployer($input: EmployerMutationInput!) {
    employerMutate(input: $input) {
      employer {
        ...EmployerInformation
      }
    }
  }
  ${fragments.employerInformation}
`

const withData = graphql(getEmployerInformation, {
  options: ({ employer }) => ({
      variables: {
        id: employer
      }
    })
  })

const withUpdateEmployer = graphql(updateEmployer, {
  name: 'updateEmployer'
})

export default compose(
  withData,
  withRouter,
  withUpdateEmployer
)(EmployerInformation)



// WEBPACK FOOTER //
// ./src/components/employer-information/index.js